import styled from "styled-components";

const colors = {
  primary: "#203b34",
  primaryLight: "#2d5347",
  secondary: "#f9ae17",
  terciary: "#E03A85",
  white: "#ffffff",
  gray: "#6b7280",
  grayLight: "#e5e7eb",
  grayBg: "#f9fafb",
  dark: "#1f2937",
  pending: "#9e9e9e",
  draft: "#2196f3",
  confirm: "#03a9f4",
  toAuto: "#ff9800",
  autoEval: "#ffc107",
  toEval: "#ff5722",
  evaluated: "#4caf50",
  notified: "#8bc34a",
};

export const StatsContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const StatsContainer = styled.div`
  background: linear-gradient(
    135deg,
    ${colors.primary} 0%,
    ${colors.primaryLight} 100%
  );
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -10%;
    width: 400px;
    height: 400px;
    background: rgba(249, 174, 23, 0.1);
    border-radius: 50%;
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -30%;
    left: -5%;
    width: 300px;
    height: 300px;
    background: rgba(249, 174, 23, 0.05);
    border-radius: 50%;
    z-index: 0;
  }
`;

export const ThTitle = styled.div`
  font-size: 1rem;
  background-color: #203b34;
  color: #fff;
  border-right: 1px solid #fff;
  padding: 8px 10px;
`;

export const TdCell = styled.div`
  font-size: 0.875rem;
  background-color: ${({ $odd }) => ($odd ? "#fff" : "#fafafa")};
  color: #000;
  border-left: ${({ $first }) =>
    $first ? "1px solid #dcdcdc" : "0px solid #dcdcdc"};
  border-right: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  padding: 5px 10px;
  height: 45px;
`;

export const StatusContainer = styled.div`
  height: 40px;
`;

export const ButtonAction = styled.button`
  margin-right: 2px;
  color: #f9ae17;
  font-size: 1rem;
  border: 0px;
  background: transparent;
  width: max-content;

  &:hover {
    color: #ff9800;
    font-size: 1rem;
  }
`;

export const IconStatus = styled.i`
  color: ${({ $active }) => ($active ? "green" : "#e9e9e9")};
  font-size: 0.85rem;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const IconStatusHead = styled.i`
  color: #fff;
`;

export const IconContainer = styled.div`
  padding-right: 5px;
  padding-left: 5px;
  font-size: 0.85rem;
`;
